import React from "react";
import { Link } from "react-router-dom";
import { HERO_IMG } from "../lib/categories";

export default function About() {
  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-16">
      <div className="relative rounded-[32px] overflow-hidden min-h-[380px] flex items-end mb-16">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D530E]/85 to-[#0D530E]/20" />
        <div className="relative z-10 p-10 sm:p-14 max-w-2xl">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-[#E7E1B1] mb-3">About AfriGate</p>
          <h1 className="font-display text-5xl sm:text-6xl font-light text-[#FBF5DD] leading-[0.95] tracking-tight">
            Connecting Africa to the world's best products
          </h1>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        <div className="space-y-5 text-[#306D29]/85 font-light text-lg leading-relaxed">
          <p>AfriGate makes shopping from the UK feel simple and safe. We source genuine products from trusted UK retailers, buy on your behalf or receive your own orders, then carefully check and pack every item.</p>
          <p>Our team handles the cross-border headache of international shipping, customs and last-mile delivery, so you never have to chase couriers or worry about what's happening in between.</p>
          <p>From fashion and beauty to groceries, electronics, gifts and everyday essentials, we make sure your purchases arrive as expected. It's your favourite UK stores, delivered home with convenience, reliability and peace of mind.</p>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[["🇬🇧 → 🇬🇭", "First corridor live"], ["7", "Product categories"], ["Model A", "Order-then-source"], ["Gift Boxes", "Monthly subscriptions"]].map(([v, l]) => (
            <div key={l} className="rounded-2xl bg-[#E7E1B1]/40 border border-[#0D530E]/5 p-6">
              <p className="font-display text-2xl text-[#0D530E]">{v}</p>
              <p className="text-sm text-[#306D29]/80 mt-1">{l}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="rounded-[32px] bg-[#E7E1B1]/40 border border-[#0D530E]/5 p-12 mt-16 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div>
          <h2 className="font-display text-3xl text-[#0D530E]">Have questions?</h2>
          <p className="text-[#306D29]/80 font-light mt-1">See how the whole journey works, from shelf to door.</p>
        </div>
        <Link to="/how-it-works" className="bg-[#306D29] hover:bg-[#0D530E] text-[#FBF5DD] font-medium px-8 py-4 rounded-full shrink-0" style={{ transition: "background-color 0.2s ease" }}>
          How it works
        </Link>
      </div>
    </div>
  );
}
